import { Star, ArrowUpRight } from "lucide-react";
import { GOOGLE_REVIEWS_URL } from "@/lib/data";

export default function GoogleReviewsBadge({ variant = "light" }) {
  const dark = variant === "dark";
  return (
    <a
      href={GOOGLE_REVIEWS_URL}
      target="_blank"
      rel="noreferrer"
      data-testid="google-reviews-badge"
      className={`group inline-flex items-center gap-5 border ${dark ? "border-white/20 bg-white/[0.04] hover:bg-white/10" : "border-black/15 bg-[color:var(--paper)] hover:bg-[color:var(--cream-2)]"} px-6 py-4 transition-colors`}
    >
      <div className={`h-10 w-10 rounded-full flex items-center justify-center text-lg font-medium ${dark ? "bg-white text-[color:var(--ink)]" : "bg-[color:var(--burgundy)] text-[color:var(--cream)]"}`}>G</div>
      <div>
        <div className={`text-[10px] tracking-[0.24em] uppercase ${dark ? "text-white/60" : "text-[color:var(--ink-2)]"}`}>Original­bewertungen auf</div>
        <div className={`font-serif text-lg leading-none mt-1 ${dark ? "text-white" : "text-[color:var(--ink)]"}`}>Google Business Profil</div>
        <div className="flex items-center gap-1 mt-2 text-[color:var(--burgundy)]">
          {[...Array(5)].map((_, i) => <Star key={i} className="h-3.5 w-3.5 fill-current" />)}
          <span className={`ml-2 text-xs ${dark ? "text-white/70" : "text-[color:var(--ink-2)]"}`}>5,0 · Kunden­bewertungen</span>
        </div>
      </div>
      <ArrowUpRight className={`h-4 w-4 ${dark ? "text-white" : "text-[color:var(--ink)]"} group-hover:translate-x-1 group-hover:-translate-y-1 transition-transform`} />
    </a>
  );
}
